import { render } from "./scriptTemplates.vue?vue&type=template&id=d657a5b4"
import script from "./scriptTemplates.vue?vue&type=script&lang=js"
export * from "./scriptTemplates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__